import { Events } from 'core/infrastructure';

export type CloseSessionType = 'ALLOW_CLOSE_SESSION' | 'DISABLE_CLOSE_SESSION';

export async function registerWhile<T>(action: () => Promise<T>): Promise<T> {

	// Tengo que evitar que se cierre la sesión mientras invoco al bridge por si éste sacase alguna pantalla pero Ágora no, como
	// ocurre, por ejemplo, al invocar las operaciones avanzadas de las máquinas de control de efectivo.
	const intervalId = setInterval(() => {
		void Events.raise('user-activity:action-in-course');
	}, 500);

	try {

		// Necesito lanzarlo por si se activase la inactividad justo mientras se ejecuta la acción
		// antes de que se ejecute el primer setInterval
		void Events.raise('user-activity:action-in-course');

		return await action();
	}
	finally {
		clearInterval(intervalId);
	}
}